import * as Cookies from 'js-cookie'

import { app } from '@/main'
import camelcaseKeys from 'camelcase-keys'
// https://vuex.vuejs.org/en/actions.html
import cashRegisterService from '@/services/cash-registers'
import { cookieDomain } from '@/utils/variables'
import customerService from '@/services/customers'
import productService from '@/services/products'
import snakecaseKeys from 'snakecase-keys'

export default {
  CANCEL_PENDING_REQUESTS (context) {
    context.state.cancelTokens.forEach((request, i) => {
      if (request.cancel) {
        request.cancel('CANCEL')
      }
    })

    context.commit('CLEAR_CANCEL_TOKENS')
  },

  SET_PRINTER ({ commit }, printer) {
    commit('SET_PRINTER', printer)
  },

  SET_MINI ({ commit }, isMini) {
    commit('SET_MINI', isMini)
  },

  SET_ONLINE ({ commit }, isOnline) {
    commit('SET_ONLINE', isOnline)
  },

  SET_SHOW_FULL_CATALOG ({ commit }, showFullCatalog) {
    commit('SET_SHOW_FULL_CATALOG', showFullCatalog)
  },

  SET_FULLSCREEN ({ commit }, isFullScreen) {
    commit('SET_FULLSCREEN', isFullScreen)
  },

  SAVE_CASH_REGISTER ({ commit, dispatch }, cashRegisterIdentifier) {
    return cashRegisterService.install(cashRegisterIdentifier)
      .then((data) => {
        commit('SET_IDENTIFIER', cashRegisterIdentifier)
        dispatch('FETCH_CASH_REGISTER', cashRegisterIdentifier)
        return Promise.resolve(data.data)
      })
      .catch((data) => Promise.reject(data.data))
  },

  FETCH_CASH_REGISTER ({ commit }, cashRegisterIdentifier) {
    return cashRegisterService.get(cashRegisterIdentifier)
      .then((data) => {
        commit('SET_CASH_REGISTER', camelcaseKeys(data.data.cash_register, { deep: true }))
        return Promise.resolve(data.data.cash_register)
      })
      .catch((data) => Promise.reject(data.data))
  },

  CLOSE_CASH_REGISTER ({ dispatch, state }, cashRegisterReport) {
    return cashRegisterService.closed(snakecaseKeys(cashRegisterReport, { deep: true }))
      .then(data => {
        if (localStorage.closeCountedValues) localStorage.removeItem('closeCountedValues')
        if (localStorage.closeCountedTotal) localStorage.removeItem('closeCountedTotal')
        if (Cookies.get('cashRegisterOpened')) Cookies.remove('cashRegisterOpened', { domain: cookieDomain })
        return Promise.resolve(data.data)
      })
      .catch(data => Promise.reject(data.data))
      .finally(() => dispatch('FETCH_CASH_REGISTER', state.identifier))
  },

  SAVE_CASH_MOVEMENT ({ dispatch }, { cashRegisterIdentifier, cashMovement }) {
    return cashRegisterService.addCashMovement(cashMovement, { deep: true })
      .then(data => Promise.resolve(data.data))
      .catch(data => Promise.reject(data.data))
      .finally(() => dispatch('FETCH_CASH_REGISTER', cashRegisterIdentifier))
  },

  FETCH_PRODUCTS ({ commit, dispatch, getters }) {
    return productService.all()
      .then((data) => {
        data.data.products.forEach(function (element) {
          element.barcodes = _.uniq(_.map(element.barcodes, 'barcode').filter(Number)).join(', ')
        })
        const products = Object.freeze(data.data.products)
        commit('SET_PRODUCTS', camelcaseKeys(products, { deep: true }))

        // Automatically fetch product stocks if cash register is installed
        if (getters.isCashRegisterInstalled) {
          return dispatch('FETCH_PRODUCT_STOCKS')
        }
      })
      .catch((data) => Promise.reject(data.data))
  },

  FETCH_PRODUCT_STOCKS ({ commit }) {
    app.$wait.start('fetching product stocks')
    return productService.stocks()
      .then((data) => {
        return commit('SET_PRODUCT_STOCKS', camelcaseKeys(data.data.stocks, { deep: true }))
      })
      .catch((data) => Promise.reject(data.data))
      .finally(() => app.$wait.end('fetching product stocks'))
  },

  SAVE_CUSTOMER ({ dispatch }, customer) {
    return customerService.save(snakecaseKeys(customer, { deep: true }))
      .then((data) => {
        return data.data
      })
  },

  FETCH_CUSTOMERS ({ commit }) {
    return customerService.all()
      .then((data) => {
        const customers = Object.freeze(data.data.customers)
        return commit('SET_CUSTOMERS', camelcaseKeys(customers, { deep: true }))
      })
      .catch((data) => Promise.reject(data.data))
  }
}
